import { useMemo } from 'react';

import { useGetCollections } from '@hero/services';

export function useGetCollectionsHelper() {
  const { data: featuredCollection, isFetched: featuredIsFetched } = useGetCollections(
    {
      pagination: {
        page: 1,
        limit: 50
      },
      filters: {
        isPublic: true
      }
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity
    }
  );

  const { data: savedCollections, isFetched: savedIsFetched } = useGetCollections(
    {
      pagination: {
        page: 1,
        limit: 50
      },
      filters: {
        isPublic: false
      }
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity
    }
  );

  const allCollections = useMemo(() => {
    if (featuredIsFetched && savedIsFetched) {
      return [...(savedCollections?.docs || []), ...(featuredCollection?.docs || [])];
    }

    return [];
  }, [savedCollections, featuredCollection]);

  return {
    allCollections
  };
}
